import usePost from "hooks/usePost";
import { api } from "constants/RotasAPI";
import { FiltroGestaoCobrancaContatoDTO } from "types/dto/FiltroGestaoCobrancaContatoDTO";
import toast from "react-hot-toast";
import { AxiosError } from "axios";
import { ResponseError } from "types/dto/ResponseError";

export const usePostRelatorioGestaoCobranca = (unidadeId: number, condominioId: number) => {
    
    const onSuccess = (response: any) => {
        if (response) {
            try {
                let base64PDF = response.data;
                const base64Prefix = "data:application/pdf;base64,";
                if (base64PDF.startsWith(base64Prefix)) {
                    base64PDF = base64PDF.replace(base64Prefix, "");
                }
                
                const byteCharacters = atob(base64PDF);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/pdf" });
                const url = URL.createObjectURL(blob);
                
                window.open(url, "_blank");
                toast.success("Relatório gerado com sucesso.");
            } catch (error) {
                toast.error("Erro ao processar o PDF. Verifique o formato da resposta.");
                console.error("Erro ao decodificar Base64:", error);
            }
        } else {
            toast.error("Erro ao processar o PDF.");
        }
    };
 
    const onError = (error: AxiosError<ResponseError>) => {
        if (error?.response?.data?.validation[0]?.message) {
          toast.error(error.response.data.validation[0].message);
        } else {
            toast.error("Erro ao salvar registro.");
        }
      };

    const payload: FiltroGestaoCobrancaContatoDTO = { unidadeId, condominioId };

    return usePost<FiltroGestaoCobrancaContatoDTO>({
        url: api.gestaoCobranca.postRelatorioGestaoCobrancaRealizadas,
        onSuccess,
        onError,
    });
};